import { createRoute, redirect } from '@tanstack/react-router'
import { lazy } from 'react'
import { listSearch } from '../list-search'
import type { LazyPage } from './lazy-page'
import { rootRoute } from './root'

const ComposePage: LazyPage = lazy(() =>
  import('../../routes/messaging/ComposePage').then((m) => ({
    default: m.ComposePage,
  })),
)
const ScheduledListPage: LazyPage = lazy(() =>
  import('../../routes/messaging/ScheduledListPage').then((m) => ({
    default: m.ScheduledListPage,
  })),
)
const ScheduledEditorPage: LazyPage<{ id: string }> = lazy(() =>
  import('../../routes/messaging/ScheduledEditorPage').then((m) => ({
    default: m.ScheduledEditorPage,
  })),
)
const SentListPage: LazyPage = lazy(() =>
  import('../../routes/messaging/SentListPage').then((m) => ({
    default: m.SentListPage,
  })),
)
const InboxPage: LazyPage = lazy(() =>
  import('../../routes/messaging/InboxPage').then((m) => ({
    default: m.InboxPage,
  })),
)
const ListsPage: LazyPage = lazy(() =>
  import('../../routes/messaging/ListsPage').then((m) => ({
    default: m.ListsPage,
  })),
)
// Messaging's views are tabs in the top bar: /messaging/scheduled ·
// /messaging/sent, with one scheduled message at /messaging/scheduled/$id and
// the composer at /messaging/new. Bare /messaging lands on the schedule.
const messagingRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/messaging',
  beforeLoad: () => {
    throw redirect({ to: '/messaging/scheduled' })
  },
})
const composeRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/messaging/new',
  component: ComposePage,
})
const sentRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/messaging/sent',
  component: SentListPage,
  validateSearch: listSearch,
})
const scheduledRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/messaging/scheduled',
  component: ScheduledListPage,
  validateSearch: listSearch,
})
const inboxRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/messaging/inbox',
  component: InboxPage,
  validateSearch: listSearch,
})
const listsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/messaging/lists',
  component: ListsPage,
})
function ScheduledEditorView() {
  const { id } = scheduledEditorRoute.useParams()
  return <ScheduledEditorPage id={id} />
}
const scheduledEditorRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/messaging/scheduled/$id',
  component: ScheduledEditorView,
})

export const messagingRoutes = [
  messagingRoute,
  composeRoute,
  sentRoute,
  scheduledRoute,
  inboxRoute,
  listsRoute,
  scheduledEditorRoute,
]
